import axios from 'axios';
import { API_URL } from '@/lib/config.ts';
import { toast } from 'sonner';

const axiosInstance = axios.create({
  baseURL: API_URL,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Values are stored as strings in localStorage by useLocalStorage hook
    const rawAccessToken = localStorage.getItem('access_token');

    if (!rawAccessToken) {
      return config;
    }

    try {
      const accessToken: string | null = JSON.parse(rawAccessToken);

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
    } catch (error) {
      console.error('Error parsing access token from localStorage', error);
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error(error);

    // If the error is not a 401, redirect lo login page if not already there
    if (
      error.response.status === 401 &&
      !window.location.pathname.includes('login') &&
      !window.location.pathname.includes('logout')
    ) {
      console.debug('Session expired!');
      // Redirect to logout page
      const message =
        'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.';
      window.location.href = `/logout?message=${message}`;
      return Promise.reject(error);
    }

    if (error.response.status === 500) {
      toast.error(
        'Ha ocurrido un error, por favor intenta nuevamente más tarde.',
      );
    }

    // If we're in development, show the error message
    if (process.env.NODE_ENV === 'development') {
      const message = error.message ?? 'An error occurred';
      const details = error.response.data.message ?? 'No details available';
      toast.error(`${message}: ${details}`);
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
